"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { syncBitrixTraceSnapshot } from "@/lib/attribution/capture-client";
import { isInternalJourneyPath } from "@/lib/attribution/trace";

/**
 * Снимок трейса Bitrix24, когда клиентский путь в B24 реально вырос.
 * Админка и повтор одних страниц не пишутся.
 */
export function AttributionCapture() {
  const pathname = usePathname();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (isInternalJourneyPath(pathname)) return;
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    const timer = window.setTimeout(() => {
      void syncBitrixTraceSnapshot();
    }, 1200);
    return () => window.clearTimeout(timer);
  }, [pathname]);

  return null;
}
